<template>
  <v-container>
    <v-row class="align-center mb-3">
      <v-col>
        <h1 class="display-1">Billing information</h1>
      </v-col>
      <v-col cols="auto">
        <v-btn @click="openEditDialog" color="success">
          <v-icon class="mr-1">mdi-pencil</v-icon>
          Edit
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card elevation="1" class="stats-card">
          <v-card-title>Account info</v-card-title>
          <v-col cols="12" class="pl-0 pt-0">
        <v-list dense class="pt-0">
          <v-list-item>
            <v-list-item-content>Routing Number</v-list-item-content>
            <span>
              {{ this.billing.ROUTING_NUMBER || 'Not set' }}
            </span>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>Account Number</v-list-item-content>
            <span>
              {{ this.billing.ACCOUNT_NUMBER || 'Not set' }}
            </span>
          </v-list-item>
          </v-list>
          </v-col>
        </v-card>
      </v-col>
    </v-row>

    <!-- Edit Billing Information Modal -->
    <v-dialog v-model="editDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Billing Information</span>
        </v-card-title>
        
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedBilling.ROUTING_NUMBER"
                    :rules="routingNumberRules"
                    label="Routing Number"
                    placeholder="123456789"
                    maxlength="9"
                    outlined
                    required
                    @input="formatRoutingNumber"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedBilling.ACCOUNT_NUMBER"
                    :rules="accountNumberRules"
                    label="Account Number"
                    placeholder="Enter account number"
                    maxlength="17"
                    outlined
                    required
                    @input="formatAccountNumber"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeEditDialog">
            Cancel
          </v-btn>
          <v-btn 
            color="blue darken-1" 
            text 
            @click="saveBillingInfo"
            :disabled="!valid"
            :loading="saving"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Success Snackbar -->
    <v-snackbar v-model="snackbar" :timeout="3000" color="success">
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Error Snackbar -->
    <v-snackbar v-model="errorSnackbar" :timeout="5000" color="error">
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="errorSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<!--<v-tabs v-model="tab" background-color="transparent" grow>-->
<!--  <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>-->
<!--</v-tabs>-->

<!--<v-tabs-items v-model="tab">-->
<!--  <v-tab-item v-for="item in items" :key="item">-->
<!--    <template v-if="item == 'Details' && patient_data.length != 0">-->
<!--      <v-row class="pa-6 pb-0">-->
<!--        <v-col cols="12" sm="12" md="6" lg="3">-->
<!--          <v-card elevation="2" class="stats-card">-->
<!--            <v-card-title> Patient Info </v-card-title>-->
<!--            <v-col cols="12" class="pl-0 pt-0">-->
<!--              <v-list dense class="pt-0">-->
<!--                <v-list-item>-->
<!--                  <v-list-item-content>Patient ID</v-list-item-content>-->
<!--                  <span>-->
<!--                          {{ patient_data.PATIENT_ID }}-->
<!--                        </span>-->
<!--                </v-list-item>-->
<!--                <v-list-item>-->
<!--                  <v-list-item-content>Sex</v-list-item-content>-->
<!--                  <span>-->
<!--                          {{ patient_data.SEX }}-->
<!--                        </span>-->
<!--                </v-list-item>-->
<!--                <v-list-item>-->
<!--                  <v-list-item-content>DOB</v-list-item-content>-->
<!--                  <span>-->
<!--                          {{ patient_data.BIRTH_DATE }}-->
<!--                        </span>-->
<!--                </v-list-item>-->
<!--                <v-list-item>-->
<!--                  <v-list-item-content>Phone</v-list-item-content>-->
<!--                  <span>-->
<!--                          {{ patient_data.PHONE }}-->
<!--                        </span>-->
<!--                </v-list-item>-->
<!--              </v-list>-->
<!--            </v-col>-->
<!--            <v-card-text class="pt-0 pb-0 body-1">{{ patient_data.ADDRESS }}</v-card-text>-->
<!--            <v-card-text class="pt-0 pb-0 body-1"-->
<!--            >{{ patient_data.CITY }}, {{ patient_data.STATE }}</v-card-text-->
<!--            >-->
<!--          </v-card>-->
<!--        </v-col>-->

<!--        <v-col cols="12" sm="12" md="6" lg="3">-->
<!--          <v-card elevation="2" class="stats-card">-->
<!--            <v-card-title> Membership Info </v-card-title>-->
<!--            <v-card-text class="pb-0 condensed body-1"-->
<!--            >Provider: {{ patient_data.PCP_NAME }}</v-card-text-->
<!--            >-->
<!--            <v-card-text class="pb-0 condensed body-1"-->
<!--            >Provider Location:-->
<!--              {{-->
<!--                patient_data.PCP_LOCATION_CODE ? patient_data.PCP_LOCATION_CODE : 'N/A'-->
<!--              }}</v-card-text-->
<!--            >-->
<!--            <v-list dense>-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>Effective Date</v-list-item-content>-->
<!--                <v-chip>-->
<!--                  {{ patient_data.ELIGIBLE_MONTH }}-->
<!--                </v-chip>-->
<!--              </v-list-item>-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>Term Date</v-list-item-content>-->
<!--                <v-chip>-->
<!--                  {{ patient_data.DISENROLLMENT_DATE }}-->
<!--                </v-chip>-->
<!--              </v-list-item>-->
<!--            </v-list>-->
<!--            <v-col cols="12" class="pl-0 pt-0"> </v-col>-->
<!--          </v-card>-->
<!--        </v-col>-->

<!--        <v-col cols="12" sm="12" md="6" lg="3">-->
<!--          <v-card elevation="2" class="stats-card">-->
<!--            <v-card-title> Finance </v-card-title>-->
<!--            <v-list dense class="pt-0">-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>Risk Score C</v-list-item-content>-->
<!--                <v-chip>-->
<!--                  {{ patient_data.RISKSCORE_C ? patient_data.RISKSCORE_C : 'N/A' }}-->
<!--                </v-chip>-->
<!--              </v-list-item>-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>Risk Score D</v-list-item-content>-->
<!--                <v-chip>-->
<!--                  {{ patient_data.RISKSCORE_D ? patient_data.RISKSCORE_D : 'N/A' }}-->
<!--                </v-chip>-->
<!--              </v-list-item>-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>Total Expenses</v-list-item-content>-->
<!--                <v-chip>-->
<!--                  ${{-->
<!--                    patient_data.TOTAL_EXPENSES-->
<!--                      ? formatCurrency(patient_data.TOTAL_EXPENSES)-->
<!--                      : 'N/A'-->
<!--                  }}-->
<!--                </v-chip>-->
<!--              </v-list-item>-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>Total Revenue</v-list-item-content>-->
<!--                <v-chip>-->
<!--                  ${{-->
<!--                    patient_data.TOTAL_REVENUE-->
<!--                      ? formatCurrency(patient_data.TOTAL_REVENUE)-->
<!--                      : 'N/A'-->
<!--                  }}-->
<!--                </v-chip>-->
<!--              </v-list-item>-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>MLR</v-list-item-content>-->
<!--                <v-chip dark :color="getMLRColor(patient_data.MLR)">-->
<!--                  {{ Math.round(parseFloat(patient_data.MLR) * 100) }}%-->
<!--                </v-chip>-->
<!--              </v-list-item>-->
<!--            </v-list>-->
<!--          </v-card>-->
<!--        </v-col>-->

<!--        <v-col cols="12" sm="12" md="6" lg="3">-->
<!--          <v-card elevation="2" class="stats-card">-->
<!--            <v-card-title> Utilization </v-card-title>-->
<!--            <v-skeleton-loader-->
<!--              :loading="loadingUtilization"-->
<!--              max-width="275"-->
<!--              type="list-item, list-item, list-item, list-item"-->
<!--            >-->
<!--              <v-list dense class="pt-0">-->
<!--                <v-list-item>-->
<!--                  <v-list-item-content>ER Visits</v-list-item-content>-->
<!--                  <v-chip>-->
<!--                    {{ patient_utilization.er_visits }}-->
<!--                  </v-chip>-->
<!--                </v-list-item>-->
<!--                <v-list-item>-->
<!--                  <v-list-item-content>Admissions</v-list-item-content>-->
<!--                  <v-chip>-->
<!--                    {{ patient_utilization.admissions }}-->
<!--                  </v-chip>-->
<!--                </v-list-item>-->
<!--                &lt;!&ndash; <v-list-item>-->
<!--                  <v-list-item-content>PCP Claims</v-list-item-content>-->
<!--                  <v-chip> {{ patient_utilization.pcp_claims }} </v-chip>-->
<!--                </v-list-item> &ndash;&gt;-->
<!--                <v-list-item>-->
<!--                  <v-list-item-content>Specialist Claims</v-list-item-content>-->
<!--                  <v-chip>-->
<!--                    {{ patient_utilization.specialists }}-->
<!--                  </v-chip>-->
<!--                </v-list-item>-->
<!--              </v-list>-->
<!--            </v-skeleton-loader>-->
<!--          </v-card>-->
<!--        </v-col>-->
<!--      </v-row>-->
<!--      <v-row class="pa-6 pt-0">-->
<!--        <v-col cols="12">-->
<!--          <PatientConditions-->
<!--            :patient="patient_id ? patient_id : null"-->
<!--            :insurance="insurance ? insurance : null"-->
<!--          />-->
<!--        </v-col>-->

<!--        <v-col cols="12">-->
<!--          <HCC :patient="patient_id" :insurance="insurance" />-->
<!--        </v-col>-->

<!--        <v-col cols="12">-->
<!--          <institutional :patient="patient_id" :insurance="insurance" />-->
<!--        </v-col>-->

<!--        <v-col cols="12">-->
<!--          <professional :patient="patient_id" :insurance="insurance" />-->
<!--        </v-col>-->

<!--        <v-col cols="12">-->
<!--          <Rx :patient="patient_id" :insurance="insurance" />-->
<!--        </v-col>-->

<!--        <v-col cols="12">-->
<!--          <laboratory :patient="patient_id" :insurance="insurance" />-->
<!--        </v-col>-->
<!--      </v-row>-->
<!--    </template>-->

<!--    <v-row v-if="item == 'Institutional'" class="pa-6">-->
<!--      <v-col cols="12">-->
<!--        <institutional :patient="patient_id" :insurance="insurance" />-->
<!--      </v-col>-->
<!--    </v-row>-->

<!--    <v-row v-if="item == 'Professional'" class="pa-6">-->
<!--      <v-col cols="12">-->
<!--        <professional :patient="patient_id" :insurance="insurance" />-->
<!--      </v-col>-->
<!--    </v-row>-->

<!--    <v-row v-if="item == 'Rx'" class="pa-6">-->
<!--      <v-col cols="12">-->
<!--        <rx :patient="patient_id" :insurance="insurance" />-->
<!--      </v-col>-->
<!--    </v-row>-->

<!--    <v-row v-if="item == 'Laboratory'" class="pa-6">-->
<!--      <v-col cols="12">-->
<!--        <laboratory :patient="patient_id" :insurance="insurance" />-->
<!--      </v-col>-->
<!--    </v-row>-->

<!--    <v-row v-if="item == 'Open Conditions'" class="pa-6">-->
<!--      <v-col cols="12">-->
<!--        <OpenConditions :patient="patient_id" :insurance="insurance" />-->
<!--      </v-col>-->
<!--    </v-row>-->

<!--    <v-row v-if="item == 'Quality'" class="pa-6">-->
<!--      <v-col cols="12">-->
<!--        <QualityGaps :patient="patient_id" :insurance="insurance" />-->
<!--      </v-col>-->
<!--    </v-row>-->

<!--    <v-row v-if="item === 'Tasks'">-->
<!--      <patient-tasks :enrolleeID="patient_id" :key="patientTasksKey" />-->
<!--    </v-row>-->

<!--    <v-row v-if="item == 'History'" class="pa-6">-->
<!--      <v-col cols="12">-->
<!--        <History :patient="patient_id" :insurance="insurance" />-->
<!--      </v-col>-->
<!--    </v-row>-->

<!--    &lt;!&ndash; <v-row v-if="item == 'Notifications'" class="pa-6">-->
<!--      <v-col cols="12">-->
<!--        <Notifications-->
<!--          :startDate="notificationsStartDate"-->
<!--          :endDate="notificationsEndDate"-->
<!--          :insurance="insurance"-->
<!--          :patient="insurance === 'Careplus' ? patient_mbi : patient_id"-->
<!--        />-->
<!--      </v-col>-->
<!--    </v-row> &ndash;&gt;-->
<!--  </v-tab-item>-->
<!--</v-tabs-items>-->
<!--</v-card>-->
<script>
import axios from 'axios';
import avatarIcon from "@/assets/icons/avatar.svg";
import moment from "moment/moment";

export default {
  name: 'BillingInformation',
  data() {
    return {
      provider: {},
      user: '',
      billing: {},
      editDialog: false,
      valid: true,
      saving: false,
      snackbar: false,
      errorSnackbar: false,
      snackbarMessage: '',
      errorMessage: '',
      editedBilling: {
        ROUTING_NUMBER: '',
        ACCOUNT_NUMBER: '',
      },
      routingNumberRules: [
        v => !!v || 'Routing Number is required',
        v => /^\d{9}$/.test(v) || 'Routing Number must be exactly 9 digits',
      ],
      accountNumberRules: [
        v => !!v || 'Account Number is required',
        v => /^\d+$/.test(v) || 'Account Number must contain only digits',
        v => (v && v.length >= 4 && v.length <= 17) || 'Account Number must be between 4-17 digits',
      ],
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    async getUser() {
      await axios
        .get('/api/user')
        .then((response) => {
          this.user = response.data[0];
          this.getBillingInformation();
        })
        .catch(err => this.$router.push('/login'));
    },
    async getBillingInformation() {
      await axios
        .get(`/api/provider/billingInformation/${this.user.npi}`)
        .then((response) => {
          this.billing = response.data[0] || {};
        })
        .catch(err => {
          console.log(err);
          this.billing = {};
        });
    },
    openEditDialog() {
      this.editedBilling = {
        ROUTING_NUMBER: this.billing.ROUTING_NUMBER || '',
        ACCOUNT_NUMBER: this.billing.ACCOUNT_NUMBER || '',
      };
      this.editDialog = true;
    },
    closeEditDialog() {
      this.editDialog = false;
      this.editedBilling = {
        ROUTING_NUMBER: '',
        ACCOUNT_NUMBER: '',
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    formatRoutingNumber() {
      // Remove non-digits and limit to 9 characters
      this.editedBilling.ROUTING_NUMBER = this.editedBilling.ROUTING_NUMBER.replace(/\D/g, '').substring(0, 9);
    },
    formatAccountNumber() {
      // Remove non-digits and limit to 17 characters
      this.editedBilling.ACCOUNT_NUMBER = this.editedBilling.ACCOUNT_NUMBER.replace(/\D/g, '').substring(0, 17);
    },
    async saveBillingInfo() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.saving = true;
      
      try {
        const response = await axios.put(
          `/api/provider/billingInformation/${this.user.npi}`,
          {
            ROUTING_NUMBER: this.editedBilling.ROUTING_NUMBER,
            ACCOUNT_NUMBER: this.editedBilling.ACCOUNT_NUMBER,
          }
        );

        // Update local billing data
        this.billing = {
          ...this.billing,
          ROUTING_NUMBER: this.editedBilling.ROUTING_NUMBER,
          ACCOUNT_NUMBER: this.editedBilling.ACCOUNT_NUMBER,
        };

        this.snackbarMessage = 'Billing information updated successfully!';
        this.snackbar = true;
        this.closeEditDialog();

      } catch (error) {
        console.error('Error updating billing information:', error);
        this.errorMessage = (error.response && error.response.data && error.response.data.error) || 'Failed to update billing information. Please try again.';
        this.errorSnackbar = true;
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
